module.exports = __webpack_public_path__ + "af66408bc94f1e1b2627a33f3f4e0e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-28.jpg
// module id = 1169
// module chunks = 0